import backIcon from 'images/back.png';
import {COMPANY_WIZARD_STEPS, stepIndex} from './steps';
import styles from './companyWizard.module.scss';

// Shared header + progress stepper shown on every Create Company step.
// - currentStepKey: which step is active (one of the step keys).
// - onBack: optional handler for the back arrow.
// - onStepClick: optional handler(key) invoked when a COMPLETED step is
//   clicked, so admins can jump back to edit an earlier step.
const CompanyWizardHeader = ({currentStepKey, onBack, onStepClick}) => {
  const current = stepIndex(currentStepKey);

  return (
    <div className={styles.wizard}>
      <div className={styles.topbar}>
        {onBack && (
          <img
            src={backIcon}
            alt="Back"
            className={styles.back}
            onClick={onBack}
          />
        )}
        <h1 className={styles.title}>Create company</h1>
      </div>

      <div className={styles.stepper}>
        {COMPANY_WIZARD_STEPS.map((step, index) => {
          const completed = index < current;
          const active = index === current;
          const clickable = completed && !!onStepClick;
          return (
            <div className={styles.step} key={step.key}>
              {index > 0 && (
                <span
                  className={`${styles.line} ${
                    index <= current ? styles['line-done'] : ''
                  }`}
                />
              )}
              <div className={styles['step-inner']}>
                <button
                  type="button"
                  disabled={!clickable}
                  onClick={() => clickable && onStepClick(step.key)}
                  className={`${styles.circle} ${
                    completed
                      ? styles['circle-done']
                      : active
                      ? styles['circle-active']
                      : styles['circle-upcoming']
                  } ${clickable ? styles.clickable : ''}`}>
                  {completed ? '✓' : index + 1}
                </button>
                <span
                  className={`${styles['step-label']} ${
                    active ? styles['label-active'] : ''
                  }`}>
                  {step.label}
                  {step.optional && (
                    <span className={styles.optional}> · optional</span>
                  )}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CompanyWizardHeader;
